<div style="text-align:center">
    <app-header></app-header>
    <app-intro></app-intro>
</div>